import { apiClient } from './client';
import type { ScenarioMessage, TimelineEvent } from './types/scenario';

interface ScenarioMessageResponse {
  id: string;
  content: string;
  member_type: string;
  character?: object;
  persona?: object;
  timeline_events?: TimelineEvent[];
}

export const messages = {
  async get(messageId: string): Promise<ScenarioMessage> {
    try {
      const response = await apiClient.get(`/scenario-messages/${messageId}/`);
      return response.data as ScenarioMessage;
    } catch (error) {
      console.error('Failed to fetch message details:', error);
      throw error;
    }
  },

  async refreshTimelineEvents(messageId: string): Promise<ScenarioMessage> {
    try {
      const response = await apiClient.post(`/scenario-messages/${messageId}/timeline-events/`);
      return response.data as ScenarioMessage;
    } catch (error) {
      console.error('Failed to refresh timeline events:', error);
      throw error;
    }
  }
};

// Export types
export type { ScenarioMessageResponse };
